import { ChangeDetectionStrategy,ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
// import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, TableColumn } from '@app/shared/table/TableColumn';
import { ConfirmDialogComponent } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { DELETE_CONFIRMATION } from '@app/shared/constants/application-constants';
import { DialogService } from '@app-admin/dialogs/dialog.service';
import { UploadMouComponent } from '@app-admin/dialogs/upload-mou/upload-mou.component';
import { UtilService } from '@app-shared/services/util.service';
import { AdminService } from '@app/admin/admin.service';
import { GetService } from '@app/shared/table/get.service';
import { DeleteService } from '@app/shared/table/delete.service';
import moment from 'moment';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-list-mou',
    templateUrl: './list-mou.component.html',
    styleUrls: ['./list-mou.component.css'],
    standalone: false
})
export class ListMouComponent implements OnInit {
    @ViewChild(ConfirmDialogComponent) confirmDialog: ConfirmDialogComponent;
  
  toggleMenu(index: number, event: MouseEvent) {
    event.stopPropagation();
  }

  @HostListener('document:click', ['$event'])
  closeMenus(event: MouseEvent) {
    const target = event.target as HTMLElement;

    const insideMenu = target.closest('.mat-menu-panel');

    // Check if click was on a menu trigger button
    const menuBtn = target.closest('[mat-menu-trigger-for]') || 
                    target.closest('button[mat-icon-button]');

    // Only hide if it's NOT inside menu and NOT on trigger
    if (!insideMenu && !menuBtn) {
      document.querySelectorAll('.mat-menu-panel').forEach(menu => {
        (menu as HTMLElement).style.display = 'none';
      });
    }
  }

  displayedColumns: string[] = ['sno','agreement_start_date','agreement_expiry_date','action'];
  // dataSource: MatTableDataSource<any>;
  serviceError: string;
  isLoading: boolean = true;
  selectedMouToDelete: any;
  mouList: any[] = [];
  warningMessage = DELETE_CONFIRMATION;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;

  tableColumns: Array<TableColumn> = [
    { name: 'S.No.', dataKey: 'sno', type: 'sequence', isSortable: false },
    { name: 'Agreement Start Date', dataKey: 'agreement_start_date', type: 'date', isSortable: true },
    { name: 'Agreement Expiry Date', dataKey: 'agreement_expiry_date', type: 'date', isSortable: true },
    { name: 'Attachment', dataKey: 'agreement_file_name', isSortable: false },
    {
      name: 'Actions',
      type: 'threeDotActions',
      rowActions: [
        { iconName: 'eye', iconTooltip: 'Preview MOU File', name: 'preview' },
        { iconName: 'edit', iconTooltip: 'Modify MOU', name: 'edit' },
        { iconName: 'history', iconTooltip: 'Show Revision History', name: 'history' },
        { iconName: 'trash', iconTooltip: 'Delete MOU', name: 'delete' }
      ]
    }
  ];
  
  rowAction(event: { rowName: string, row: any }) {
    switch (event.rowName) {
      case 'preview':
        this.previewMouFile(event.row.agreement_file);
        break;
      case 'edit':
        this.modifyMOU(event.row.id);
        break;
      case 'history':
        this.showRevisionHistory(event.row);
        break;
      case 'delete':
        this.deleteMOU(event.row.id);
        break;
    }
  }

  tableActions: Array<Actions> = [
    { iconName: 'upload', iconTooltip: 'Upload MOU', name: 'add'}
  ];

  filterAttributes = [
  {
    dataKeyName: 'all',
    name: 'All Text',
    type: 'all',
    data: ['S.No.', 'Agreement Start Date', 'Agreement Expiry Date'],
  },
  {
    dataKeyName: 'agreement_start_date',
    name: 'Start Date',
    type: 'date',
  },
  {
    dataKeyName: 'agreement_expiry_date',
    name: 'End Date',
    type: 'date',
  }
];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ListMouComponent>, 
    private dialog: MatDialog,
    private dialogSrvc: DialogService,
    private util: UtilService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private getService: GetService,
    private adminService: AdminService,
    private deleteService: DeleteService
  ) { }

  ngOnInit(): void {
    if (this.data.mouList && this.data.mouList.length > 0) {
      this.mouList = this.data.mouList;
      this.isLoading = false;
      this.cdr.markForCheck();
    } else {
      this.loadMOUs();
    }
  }

 deleteMOU(id: number) {
      this.selectedMouToDelete = id; 
      const modal = document.getElementById('confirmDialogModal');
      if (modal) {
        (modal as any).classList.add('show');
        modal.setAttribute('aria-hidden', 'false');
        modal.style.display = 'block';
      }
}

 onConfirmDelete(): void {
  if (this.selectedMouToDelete) {
  const postData = { impactedRowId: this.selectedMouToDelete };
  this.util.showLoader = true;
  this.deleteService.delete(postData, 'deleteMOU').subscribe(
    (data: any) => {
      const responseHead = data.body.responseHead;
      const successMsg = responseHead
        ? this.util.getSuccessMessage('DELETE_MOU', responseHead.statusCode, responseHead.statusDesc)
        : responseHead;
      this.util.simpleDialog({
        title: 'Deleted',
        message: "MOU deleted successfully.",
      });
      this.loadMOUs(); // Refresh list
      this.util.showLoader = false;
    },
    (err) => {
      this.util.showLoader = false;
      this.serviceError = err.responseHead
        ? this.util.getIntlErrorMessage("LIST_MOU", err.responseHead.statusCode, err.responseHead.statusDesc)
        : err;
      this.util.simpleDialog({
        title: 'Error',
        message: this.serviceError,
      });
    }
  );
  }
}

  onCancelDelete(): void {
    this.closeConfirmDialog();
  }

  private closeConfirmDialog(): void {
    const modal = document.getElementById('confirmDialogModal');
    if (modal) {
      (modal as any).classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none';
    }
    this.selectedMouToDelete = null; // Clear the selected course
  }

  private getFileDisplayName(agreement_file: string): string {
    if (!agreement_file) return '-';
    if (agreement_file.startsWith('data:')) return 'MOU File';
    const lastSlash = agreement_file.lastIndexOf('/');
    const name = lastSlash !== -1 ? agreement_file.slice(lastSlash + 1) : agreement_file;
    return name || 'MOU File';
  }

  loadMOUs() {
    this.isLoading = true;
    this.dialogSrvc.getMOUs(parseInt(this.data.orgId)).subscribe(
      (data: any) => {
        const rows = data.body.responseBody || [];
        rows.forEach(element => {
          const expiryDate: any = new Date(element.agreement_expiry_date);
          element.is_active = expiryDate > new Date();
        });
        this.mouList = rows.map((element, index) => ({
          ...element,
          sno: index + 1,
          agreement_file_name: this.getFileDisplayName(element.agreement_file)
        }));
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      (err: any) => {
        this.util.errorNotification(err);
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    );
  }

  tableActionEmitter(event: any) {
    if (event === 'add') {
      this.addMOUPopup();
    }
  }

  addMOUPopup(data?: any) {
    const isNew = !data; 
    
    // Close the current list-mou dialog first
    this.dialogRef.close();
    
    // Small delay to ensure the dialog closes properly
    setTimeout(() => {
      const dialogRef = this.dialog.open(UploadMouComponent, {
        width: 'min(980px, 92vw)',
        maxWidth: '980px',
        autoFocus: false,
        data: data || { orgId: this.data.orgId, isNew: isNew },
        panelClass: 'upload-mou-dialog'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result.success) {
          // If upload was successful, refresh and show list again
          this.refreshAndShowList();
        } else if (result && result.cancelled) {
          // If upload was cancelled, check if we should show list
          this.checkAndShowList();
        }
      });
    }, 100);
  }

  refreshAndShowList() {
    this.dialogSrvc.getMOUs(parseInt(this.data.orgId)).subscribe(
      (data: any) => {
        const rows = data.body.responseBody || [];
        rows.forEach(element => {
          element.is_active = new Date(element.agreement_expiry_date) > new Date();
        });
        const tableData = rows.map((element, index) => ({
          ...element,
          sno: index + 1,
          agreement_file_name: this.getFileDisplayName(element.agreement_file)
        }));
        if (tableData.length > 0) {
          // Show list component with refreshed data - keep same size
          this.dialog.open(ListMouComponent, {
            width: 'min(1200px, 92vw)',
            maxWidth: '1200px',
            maxHeight: '80vh',
            autoFocus: false,
            panelClass: 'list-mou-dialog',
            data: {
              orgId: this.data.orgId,
              encId: this.data.encId,
              orgName: this.data.orgName,
              mouList: tableData
            }
          });
        }
      },
      (err: any) => {
        this.util.errorNotification(err);
      }
    );
  }

  checkAndShowList() {
    this.dialogSrvc.getMOUs(parseInt(this.data.orgId)).subscribe(
      (data: any) => {
        const rows = data.body.responseBody || [];
        rows.forEach(element => {
          element.is_active = new Date(element.agreement_expiry_date) > new Date();
        });
        const tableData = rows.map((element, index) => ({
          ...element,
          sno: index + 1,
          agreement_file_name: this.getFileDisplayName(element.agreement_file)
        }));
        if (tableData.length > 0) {
          this.dialog.open(ListMouComponent, {
            width: 'min(1200px, 92vw)',
            maxWidth: '1200px',
            maxHeight: '80vh',
            autoFocus: false,
            panelClass: 'list-mou-dialog',
            data: {
              orgId: this.data.orgId,
              encId: this.data.encId,
              orgName: this.data.orgName,
              mouList: tableData
            }
          });
        }
      },
      (err: any) => { this.util.errorNotification(err); }
    );
  }

modifyMOU(id) {
  this.getService.get('mouById', parseInt(id)).subscribe(
    (res: any) => {
      const mouData = res.body.responseBody[0];

      const agreementDateRanges = this.mouList.map((i: any) => ({
        start: moment(i.agreement_start_date),
        end: moment(i.agreement_expiry_date)
      }));

      const payload = {
        ...mouData,
        agreementDateRanges,
        orgId: this.data.orgId
      };

      // Call AdminService method and pass this dialogRef to close ListMouComponent temporarily
      this.adminService.openUploadMOU(payload, this.dialogRef);
    },
    (err: any) => {
      this.util.errorNotification(err);
      this.cdr.markForCheck();
    }
  );
}


  showRevisionHistory(row: any) {
    this.dialog.closeAll();
    
    // Store organization information for breadcrumb navigation
    const selectedOrg = {
      id: this.data.orgId,
      name: this.data.orgName || 'Organization'
    };
    localStorage.setItem('SelectedOrgForRevision', JSON.stringify(selectedOrg));
    localStorage.setItem('SelectedOrgId', this.data.orgId.toString());
    const encryptedOrgId = this.data.encId;  
    // this.route.navigate(['/admin/org-mou/RevisionHistory', row.id, row.agreement_start_date]);
    this.router.navigate(
      ['/admin/org-mou/RevisionHistory', row.id, row.agreement_start_date],
      { queryParams: { encryptedOrgId: encryptedOrgId } }
    );
  }

  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.dataSource.filter = filterValue.trim().toLowerCase();
  //   if (this.dataSource.paginator) {
  //     this.dataSource.paginator.firstPage();
  //   }
  // }

  previewMouFile(fileUrl: string) {
    const data = { key: fileUrl };
    this.adminService.download(data).subscribe(
      (data: any) => {
        const response = data.body.responseBody;
        window.open(response.url, '_blank');
      },
      (err: any) => {
        this.util.errorNotification(err);
        this.cdr.markForCheck();
      }
    );
  }

  closeDialog() {
    this.dialogRef.close();
  }

}